import { AnonymousStudentErrorType } from "../../../../anonymous-student-interfaces/enumerations/error-type";
import { StudentAPIBaseError } from "./student-api-base-error";

export class StudentAPIStudentNotFoundError extends StudentAPIBaseError {
	constructor(message: string = AnonymousStudentErrorType.STUDENT_NOT_FOUND_ERROR) {
		super(message);
		this.name = AnonymousStudentErrorType.STUDENT_NOT_FOUND_ERROR;
	}
}
